import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    function onClick1(icon, iconIndex, e) {
        {
            this.setIcon(icon.fileName);
        }
    }
    function repeatIcon2(icon, iconIndex) {
        return [React.createElement('li', {
                'className': 'assign-popup-algorithm-list__item',
                'onClick': onClick1.bind(this, icon, iconIndex),
                'key': '4791'
            }, React.createElement('span', {
                'style': { backgroundImage: 'url(' + this.getActiveFilePath(this.state.icon, icon.fileName) + ')' },
                'className': 'assign-popup-algorithm-list__item-image'
            }))];
    }
    return React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'assign-popup' }, React.createElement('div', { 'className': 'algorithm-name-wrapper' }, React.createElement('input', {
        'className': 'algorithm-input-field',
        'type': 'text',
        'value': this.state.name,
        'onChange': this.setName,
        'maxLength': 36
    }), React.createElement('h1', {}, 'Name This Algorithm Preset')), React.createElement('div', { 'className': 'algorithm-icon-scroller-wrapper' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'assign-popup-algorithm-list algorithm-icon-scroller algorithm-icon-scroller' },
        _.map(this.props.icons, repeatIcon2.bind(this))
    ]), React.createElement('h1', {}, 'Choose and Identifying Icon for this Algorithm Preset'))));
}